import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';

// COMPONENTS
import { QaAllOrdersGrid } from '../../components/Orders';

const styles = theme => ({});

export const QaAllOrders = withStyles(styles)(props => {
  const { classes } = props;

  return (
    <div className={classnames('flex-1', 'row-center-center', classes.gridContainer)}>
      <QaAllOrdersGrid />
    </div>
  );
});

QaAllOrders.propTypes = {};

QaAllOrders.defaultProps = {};
